// ------------------------------------
// PESSOAS COMPRANDO
// ------------------------------------
(function () {
  'use strict';
  if (previewMode) {
    // Variáveis
    const ref = 'produto-var';
    const ref2 = 'produto';
    const refEvtPrefix = 'lp-evt-gatilhos-';

    // Elementos
    const $section = $('#produto');
    const $element = $('.produto-comprando');

    // Oculta/Exibe o elemento
    function changeElShow() {
      const value = confTheme[ref2]['comprando-show'];
      value == '1' ? $element.removeClass('d-none') : $element.addClass('d-none');
      if (value == '1') {
        initpBuyCur();
      }
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'comprando-show', changeElShow);

    // Altera o texto
    function changeText() {
      const value = confTheme[ref2]['comprando-text'];
      $element.find('.md-text').html(fmtTxt(value, true));
      initpBuyCur();
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'comprando-text', changeText);
  }
})();

// ------------------------------------
// ESTOQUE
// ------------------------------------
(function () {
  'use strict';
  if (previewMode) {
    // Variáveis
    const ref = 'produto-var';
    const ref2 = 'produto';
    const refEvtPrefix = 'lp-evt-gatilhos-';

    // Elementos
    const $section = $('#produto');
    const $element = $('.produto-estoque');

    // Oculta/Exibe o elemento
    function changeElShow() {
      const value = confTheme[ref2]['estoque-show'];
      value == '1' ? $element.removeClass('d-none') : $element.addClass('d-none');
      if (value == '1') {
        initStockView();
      }
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'estoque-show', changeElShow);

    // Altera o texto
    function changeText() {
      const value = confTheme[ref2]['estoque-text'];
      $element.find('.md-text').html(fmtTxt(value, true));
      initStockView();
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'estoque-text', changeText);

    // Altera o tipo
    function changeTipo() {
      const value = confTheme[ref2]['estoque-tipo'];
      $element.data('estoque-tipo', value);
      initStockView();
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'estoque-tipo', changeTipo);

    // Altera a quantidade
    function changeQtde() {
      const value = confTheme[ref2]['estoque-ficticio'];
      $element.data('estoque-ficticio', value);
      initStockView();
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'estoque-ficticio', changeQtde);

    // Altera a porcentagem
    function changePercent() {
      const value = confTheme[ref2]['estoque-percent'];
      $element.find('.produto-estoque-barra span').css('width', value + '%');
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'estoque-percent', changePercent);

    // Altera a cor de fundo
    function changeBgColor() {
      const color = confTheme[ref]['estoque-bg-color'];
      if ($section.length > 0) {
        $section[0].style.setProperty('--estoque-bg-color', color);
      }
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'estoque-bg-color', changeBgColor);

    // Altera a cor do texto
    function changeTxtColor() {
      const color = confTheme[ref]['estoque-txt-color'];
      if ($section.length > 0) {
        $section[0].style.setProperty('--estoque-txt-color', color);
      }
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'estoque-txt-color', changeTxtColor);
  }
})();

// ------------------------------------
// CONTADOR
// ------------------------------------
(function () {
  'use strict';
  if (previewMode) {
    // Variáveis
    const ref = 'produto-var';
    const ref2 = 'produto';
    const refEvtPrefix = 'lp-evt-gatilhos-';

    // Elementos
    const $section = $('#produto, #produto-kits');
    const $element = $('.countdown-wrapper');

    // Oculta/Exibe o elemento
    function changeElShow() {
      const value = confTheme[ref2]['countdown-show'];
      value == '1' ? $element.removeClass('d-none') : $element.addClass('d-none');
      if (value == '1') {
        initCountdown();
      }
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'countdown-show', changeElShow);

    // Altera o texto
    function changeText() {
      const value = confTheme[ref2]['countdown-text'];
      $element.find('.countdown-desc').html(fmtTxt(value, true));
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'countdown-text', changeText);

    // Alterna o contador fixo
    function changeFixo() {
      const value = confTheme[ref2]['countdown-fixed'];
      value == '1' ? $element.addClass('fixed') : $element.removeClass('fixed');
      handlePaddingPagCountFixed();
      handleWhatsLatPos();
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'countdown-fixed', changeFixo);

    // Altera a posição do contador fixo
    function changeFixoPos() {
      const value = confTheme[ref2]['countdown-fixed-pos'];
      $element.removeClass('bottom top').addClass(value);
      handlePaddingPagCountFixed();
      handleWhatsLatPos();
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'countdown-fixed-pos', changeFixoPos);

    // Altera o tempo do contador
    function changeMinutes() {
      const value = confTheme[ref2]['countdown-minutes'];
      $element.find('.countdown').data('minutes', value);
      initCountdown();
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'countdown-minutes', changeMinutes);

    // Altera a cor de fundo
    function changeBgColor() {
      const color = confTheme[ref]['countdown-bg-color'];
      if ($section.length > 0) {
        $section[0].style.setProperty('--countdown-bg-color', color);
      }
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'countdown-bg-color', changeBgColor);

    // Altera a cor do texto
    function changeTxtColor() {
      const color = confTheme[ref]['countdown-txt-color'];
      if ($section.length > 0) {
        $section[0].style.setProperty('--countdown-txt-color', color);
      }
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'countdown-txt-color', changeTxtColor);

    // Altera a cor do número
    function changeNumberColor() {
      const color = confTheme[ref]['countdown-number-color'];
      if ($section.length > 0) {
        $section[0].style.setProperty('--countdown-number-color', color);
      }
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'countdown-number-color', changeNumberColor);
  }
})();

// ------------------------------------
// SELO GARANTIA
// ------------------------------------
(function () {
  'use strict';
  if (previewMode) {
    // Variáveis
    const ref = 'produto-var';
    const ref2 = 'produto';
    const refEvtPrefix = 'lp-evt-gatilhos-';

    // Elementos
    const $secButton = $('.produto-det-seal');

    // Oculta/Exibe o selo
    function changeSealShow() {
      const value = confTheme[ref2]['seal-show'];
      value == '1' ? $secButton.removeClass('d-none') : $secButton.addClass('d-none');
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'seal-show', changeSealShow);
  }
})();
